module.exports = __webpack_public_path__ + "static/media/user-alt-slash.9c014fb4.svg";